export function setRootStyleProperty(key: string, value: string): void {
    document.documentElement.style.setProperty(key, value);
}

export function getRootStyleProperty(key: string): string {
    return document.documentElement.style.getPropertyValue(key);
}